import { render, staticRenderFns } from "./ModalGerais.vue?vue&type=template&id=028b9d3d&scoped=true&"
import script from "./ModalGerais.vue?vue&type=script&lang=js&"
export * from "./ModalGerais.vue?vue&type=script&lang=js&"
import style0 from "./ModalGerais.vue?vue&type=style&index=0&id=028b9d3d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028b9d3d",
  null
  
)

export default component.exports